import React, { useMemo } from "react";
import { Flex } from "@costar/theme-ui";
import { SearchLayout, ToolbarLayout } from "../layouts";
import { alleyWidthByBreakPoint } from "../styles";
var mapViewLayoutVariant = {
    pointerEvents: "none",
    transform: "translateY(-1000%)",
    background: "transparent",
    position: "absolute",
    width: "100%",
};
export var MapViewLayout = function (_a) {
    var isViewMoreToggled = _a.isViewMoreToggled, mapRef = _a.mapRef, showToolbar = _a.showToolbar;
    var content = useMemo(function () { return React.createElement(Flex, { position: "relative", height: "100%", width: "100%", ref: mapRef }); }, [mapRef]);
    var alley = useMemo(function () { return (!isViewMoreToggled ? React.createElement(Flex, { flexDirection: "column", height: "100%" }) : null); }, [isViewMoreToggled]);
    return (React.createElement(Flex, { sx: mapViewLayoutVariant, flexDirection: "column", width: "100%", height: "100%", minWidth: "768px" //consistent with UUI-header container
        , "automation-id": "hidden-layout-for-geo" },
        showToolbar && (React.createElement(Flex, { "automation-id": "search-page-toolbar-hidden", height: "48px", bg: "neutral.lighter" },
            React.createElement(ToolbarLayout, null))),
        React.createElement(SearchLayout, { content: content, alley: alley, alleyWidths: alleyWidthByBreakPoint, automationIdHiddenTag: "-hidden" })));
};
//# sourceMappingURL=MapViewLayout.js.map